import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './simple-tag.scss.js';

class SimpleTag extends s {
    constructor() {
        super(...arguments);
        this.tagTitle = '';
        this.active = false;
        this.additionalClasses = '';
        this.link = '#';
    }
    render() {
        const activeClass = this.active ? 'active' : 'inactive';
        if (this.link === '' || this.link === '#' || !this.link) {
            return $ `<div class="tag ${activeClass} ${this.additionalClasses}"><span class="tagName"><slot></slot></span></div>`;
        }
        return $ `<a href="${this.link}" aria-label="card link"><div class="tag ${activeClass} ${this.additionalClasses}"><span class="tagName"><slot></slot></span></div></a>`;
    }
}
SimpleTag.styles = css_248z;
__decorate([
    e({ type: String })
], SimpleTag.prototype, "tagTitle", void 0);
__decorate([
    e({ type: Boolean })
], SimpleTag.prototype, "active", void 0);
__decorate([
    e({ type: String })
], SimpleTag.prototype, "additionalClasses", void 0);
__decorate([
    e({ type: String })
], SimpleTag.prototype, "link", void 0);
customElements.define('simple-tag', SimpleTag);

export { SimpleTag };
